import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import Link from '@mui/material/Link';
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import React from "react";
import {useFormik} from "formik";
import {API_SPEC} from "../../spec/apiSpec";
import {useApi} from "../../hooks/api-hook";
import {useKeycloak} from "@react-keycloak/web";
import * as yup from "yup";
import ReactGA from "react-ga4";


const addCardsPlaceholder = "e.g\nTasigur 3\nBallad 2"

const validationSchema = yup.object().shape({
    cards: yup
        .string()
        .required(),
});

export default function AddCardsToCollection({open, handleClose}) {

    const {isLoading, data, api, initialized} = useApi();
    const {keycloak, initialized: ki} = useKeycloak();

    const formik = useFormik({
        initialValues: {},
        validationSchema,
        onSubmit: (values, {resetForm}) => {
            const cardFields = values.cards.split('\n').map(line => {
                const tokens = line.split("\t")
                return {
                    offerType: 'Have' === tokens[0],
                    collectionName: tokens[1],
                    cardName: tokens[2],
                    collectorNumber: tokens[3],
                    set: tokens[4],
                    lang: tokens[5],
                    condition: tokens[6],
                    foil: tokens[7],
                    quantity: tokens[8],
                    price: parseFloat(tokens[9].replace(",", ".")).toFixed(2) * 100,
                    active: tokens[10],
                    notes: tokens[11]
                }
            });
            const collection_add = API_SPEC.COLLECTION_ADD_BULK(cardFields)
            api(collection_add);
            resetForm();
            ReactGA.event({category: "collection", action: 'AddCardsToCollection'});
        },
    });

    return (
        <Dialog open={open} onClose={handleClose}>
            <form onSubmit={formik.handleSubmit}>
                <DialogTitle>Add cards to collection</DialogTitle>
                <DialogContent>
                    <DialogContentText margin={1}>
                        In order to add multiple cards follow <Link target="_blank"
                                                                    href="https://guildmage.notion.site/Instrukcja-dodawania-ofert-kupna-i-sprzeda-y-do-platformy-Guildmage-Market-1f7aa9385f9140b9a2e8dcfcf6827241">instructions</Link>.
                    </DialogContentText>
                    <TextField sx={{margin: 1, width: 500}}
                               id="cards"
                               name="cards"
                               label="Paste your offers here"
                               hint
                               variant="outlined"
                               multiline
                               fullWidth
                               focused={false}
                               placeholder={addCardsPlaceholder}
                               rows={10}
                               onChange={formik.handleChange}
                               value={formik.values.cards}
                    />

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button disabled={!formik.isValid} type={'submit'} onClick={handleClose}>Add</Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}
